import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import type { StatisticListItem } from "./useStatisticList";
import { formatDate } from "../../lib/FormatDate";

interface StatisticDataGridProps {
  items: StatisticListItem[];
  onRowClick: (item: StatisticListItem) => void;
}

export function StatisticDataGrid(props: StatisticDataGridProps) {
  const { items, onRowClick } = props;

  return (
    <TableContainer>
      <Table size="small">
        <TableHead>
          <TableRow>
            <TableCell>Домен</TableCell>
            <TableCell>Язык</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell align="right">Всего</TableCell>
            <TableCell align="right">Активных</TableCell>
            <TableCell align="right">Исчезнувших</TableCell>
            <TableCell align="right">Не проверялись</TableCell>
            <TableCell>Последняя публикация</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {items.map((item, index) => (
            <TableRow
              key={`${item.targetUrl}-${item.language}-${item.region}-${index}`}
              hover
              role="row"
              tabIndex={0}
              sx={{ cursor: "pointer" }}
              onClick={() => onRowClick(item)}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onRowClick(item);
                }
              }}
            >
              <TableCell>{item.targetUrl}</TableCell>
              <TableCell>{item.language}</TableCell>
              <TableCell>{item.region}</TableCell>
              <TableCell className="tabular-nums" align="right">{item.totalLinks}</TableCell>
              <TableCell align="right">{item.validLinks}</TableCell>
              <TableCell align="right">{item.invalidLinks}</TableCell>
              <TableCell align="right">{item.uncheckedLinks}</TableCell>
              <TableCell>{formatDate(item.lastPublishedAt)}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
